import React from "react";
import ReactDOM from "react-dom";
import "./image-preview-modal.css";

function ImagePreviewModal({ image, onClose }) {
  if (!image) return null;

  const cleanUrl = image.split("?")[0].toLowerCase();

  const isPdf = cleanUrl.endsWith(".pdf");

  const isImage =
    cleanUrl.endsWith(".png") ||
    cleanUrl.endsWith(".jpg") ||
    cleanUrl.endsWith(".jpeg") ||
    cleanUrl.endsWith(".gif") ||
    cleanUrl.endsWith(".webp") ||
    cleanUrl.endsWith(".bmp");

  return ReactDOM.createPortal(
    <div className="bh-image-preview-modal" onClick={onClose}>
      <div
        className="bh-image-preview-content"
        onClick={(e) => e.stopPropagation()}
      >
        {isPdf ? (
          <iframe
            src={image}
            title="Attachment Preview"
            className="bh-image-preview-file"
          />
        ) : isImage ? (
          <img
            src={image}
            alt="Preview"
            className="bh-image-preview-file"
          />
        ) : (
          <div className="bh-preview-fallback">
            <p>This file cannot be previewed.</p>

            <a
              href={image}
              target="_blank"
              rel="noopener noreferrer"
              className="attachment-btn"
            >
              Open Attachment
            </a>
          </div>
        )}

        <button
          className="bh-image-preview-close"
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>,
    document.body
  );
}

export default ImagePreviewModal;